
import {
  BlockText,
} from '../implementations';


const mappers = {
  text: BlockText,
};

export default mappers;

